import React from 'react'
import t from 'prop-types'
import { Link } from 'gatsby'
import IconChevronRight from '../../Icons/IconChevronRight'

const PillarRelatedReading = ({ data }) => {
  return data?.link?.url ? (
    <div className="max-w-screen-md mx-auto px-5 lg:px-0 my-16 lg:my-20">
      <Link
        className="block group relative rounded-lg sm:rounded-xl bg-gray-700 p-6 pr-16 sm:p-10 sm:pr-20"
        to={data.link.url}
        target={data.link.target || null}
      >
        <div className="absolute top-1/2 transform -translate-y-1/2 right-8">
          <IconChevronRight></IconChevronRight>
        </div>

        <div className="font-bold text-white uppercase text-sm leading-tight tracking-spacious mb-3 sm:mb-4">
          {data.label}
        </div>

        <div className="font-serif font-bold text-2xl text-blue-200 group-hover:underline leading-tight">
          {data.link.title}
        </div>
      </Link>
    </div>
  ) : (
    ''
  )
}

PillarRelatedReading.propTypes = {
  data: t.object,
}

PillarRelatedReading.defaultProps = {}

export default PillarRelatedReading
